import React from 'react';
import { Route } from 'react-router-dom';
import Levels from '../pages/levels/Levels';
import LevelsArchive from '../pages/levels/LevelsArchive';
import CreateLevel from '../pages/levels/CreateLevel';
import EditLevel from '../pages/levels/EditLevel';
import PermissionGuard from '../components/global/PermissionGuard';

const levelsRoutes = (
    <>
        <Route
            path="/levels"
            element={
                <PermissionGuard permission="levels_list">
                    <Levels />
                </PermissionGuard>
            }
        />

        <Route
            path="/levels/archive"
            element={
                <PermissionGuard permission="levels_archive_list">
                    <LevelsArchive />
                </PermissionGuard>
            }
        />

        <Route
            path="/levels/create"
            element={
                <PermissionGuard permission="levels_create">
                    <CreateLevel />
                </PermissionGuard>
            }
        />

        <Route
            path="/levels/:id/edit"
            element={
                <PermissionGuard permission="levels_edit">
                    <EditLevel />
                </PermissionGuard>
            }
        />
    </>
);

export default levelsRoutes;
